import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse,
} from '@angular/common/http'; 
import { Router } from '@angular/router';

import { Observable } from 'rxjs';
import { tap, finalize } from 'rxjs/operators';
import { MatDialog } from "@angular/material/dialog";

import { MessageService } from './message.service';
import { LoaderService } from './loader.service';
import { AlertComponent } from '../components/alert/alert.component';
import { AuthService } from './auth.service';
import { GlobalCfgService } from './globalcfg.service';
import { SidenavbarViewService } from './sidenavbar-view.service';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
  
  constructor(
    private router: Router,
    private dialog: MatDialog,
    private msgService: MessageService,
    private loaderService: LoaderService,
    private authService: AuthService,
    private globalCfgService: GlobalCfgService,
    private sidenavbarViewService: SidenavbarViewService
  ) {}
 
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const started = Date.now();
    let ok: string;

    this.loaderService.show();

    return next.handle(request)
      .pipe(
        tap (
        (event: HttpEvent<any>) => {
          ok = event instanceof HttpResponse ? 'succeeded' : ''
        }, 
        (err: any) => {
          ok = 'failed';
          // if (err instanceof HttpErrorResponse) {
            // console.log('======>', err, err.error.error);

            

            var errMsg = '';
            if (err.status == 0) {
              errMsg = err.status + ': Could not connect to the server'
            }

            if (err.error.error) {
              if (err.error.error.name === 'AUTHORIZATION_REQUIRED') {
                this.router.navigateByUrl('/');
              }

              if (err.error.error.name === 'SESSION_EXPIRED') {
                const sessionExpireddialogRef = this.dialog.open(AlertComponent, {
                  width: "600px",
                  data: {
                    title: 'Session Expired',
                    note: 'User session expired. Please re-login.'
                  }
                });
                 
                sessionExpireddialogRef.afterClosed().subscribe(() => {
                  this.authService.logout().subscribe(() => {
                    this.globalCfgService.setLoggedInUser(null, null);
                    this.sidenavbarViewService.childView = undefined;
                    this.router.navigateByUrl('/');
                  },(error) => {
                    console.log(error);
                    this.globalCfgService.setLoggedInUser(null, null);
                  });
                });
              }

              errMsg = err.status + ': '+ err.error.error.message;
            }
            
            this.msgService.showError(errMsg);
            
        }),
        finalize(() => {
          const elapsed = Date.now() - started;
          const msg = `${request.method} "${request.urlWithParams}"
             ${ok} in ${elapsed} ms.`;
          // console.log(msg);
          this.loaderService.hide();
        })
      );
  }
}